import { useEffect } from "react";
import { message } from "antd";
import { useNavigate } from "react-router-dom";

import auth from "../services/authService";

function LogoutAgent() {
  const navigate = useNavigate();

  useEffect(() => {
    message.info("Please contact admin to provide access to a workspace");
    localStorage.removeItem("activeProject");
    auth.logout();
    navigate("/login");
  }, []);

  return null;
}

export default LogoutAgent;
